module.exports = __webpack_public_path__ + "static/media/Chasse Theater Logo.5ae0d789.jpg";